import { properDate } from './dateUtilities';

export const sortByDateProp =
  (prop, dir = 'desc') =>
  (a, b) => {
    const [aTime, bTime] = [a, b].map((n) => {
      if ((prop !== 'todos' && n.type === 'todos') || n.type === 'notes') {
        prop = 'creationDatetime';
      }
      return new Date(properDate(n[prop])).getTime();
    });

    if (dir === 'desc') {
      return bTime - aTime;
    }
    return aTime - bTime;
  };

export default sortByDateProp;
